module.exports = __webpack_public_path__ + "assets/b20eb27af182eab27d074e9572464e9b.svg";